import { useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router";
import { isAuthenticated } from "@/lib/auth";
import RealtimeProvider from "@/providers/RealtimeProvider";
import { useAuthStore } from "@/stores/authStore";
import { useResolvedTheme } from "@/stores/appearanceStore";
import { CoShellPortalContext } from "@/app/routes/dashboard/CoShellPortalContext";
import { SessionGateDialog } from "@/components/gettingIn/SessionDialogs";
import "@/app/routes/dashboard/cockpit.css";

const ProtectedLayout = () => {
  const { pathname, search } = useLocation();
  const user = useAuthStore((s) => s.user);
  const theme = useResolvedTheme();
  const [portal, setPortal] = useState<HTMLDivElement | null>(null);

  if (!isAuthenticated()) {
    // The query string comes along: an emailed link (?org=&brand=&planId=)
    // must land on the same page after sign-in.
    return <Navigate to={`/login?redirect=${encodeURIComponent(pathname + search)}`} />;
  }

  return (
    <RealtimeProvider>
      <Outlet />
      {/* Figma 10 · Session 01: a session that ends mid-work asks for the
          password over the page (lib/api's gate). Its own .co-shell scope so
          the dialog's tokens resolve over any page. */}
      <div ref={setPortal} className={`co-shell${theme === "dark" ? " dark" : ""}`} style={{ display: "contents" }}>
        <CoShellPortalContext.Provider value={portal}>
          <SessionGateDialog email={user?.email ?? null} hasPassword={user?.hasPassword ?? true} />
        </CoShellPortalContext.Provider>
      </div>
    </RealtimeProvider>
  );
};

export default ProtectedLayout;
